import { createContext } from 'react';

import type { OpenPixStoreState } from '../dataLayer/OpenPixStore.tsx';

export type OpenPixContextProps = {
  setOpenPixState: (state: OpenPixStoreState) => OpenPixStoreState;
  openPixState: OpenPixStoreState;
};

const OpenPixContext = createContext<OpenPixContextProps>({
  // eslint-disable-next-line
  setOpenPixState: (state: OpenPixStoreState) => ({}),
  openPixState: {},
});

export default OpenPixContext;
